// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start()
// require("turbolinks").start()
require("@rails/activestorage").start()
require("../chat_timestamps")
require("channels")
require("./jquery.min")
require("./jquery.signaturepad")
require("./jquery.signaturepad.min")
require("./flashcanvas")
require("./json2.min")
require("jquery-ui")
require("./jquery.multiselect")
window.jQuery = $;
window.$ = $;
require("select2")
require("slick-carousel")
require("intl-tel-input")
require("intl-tel-input/build/js/intlTelInput-jquery")
require("sweetalert2")
require("toastr")
require("./lazysizes.min")
require("./datatables.min")//datatable js file
require('./moment.min')
require("./bootstrap-datetimepicker.min")
// require("@nathanvda/cocoon")
import '../stylesheets/application'
import 'bootstrap'
import 'bootstrap/dist/js/bootstrap'
import '../stylesheets/style.scss'
import "@fortawesome/fontawesome-free/css/all.css";
import 'intl-tel-input'
import 'intl-tel-input/build/css/intlTelInput'
import 'select2/dist/css/select2.css'
import 'slick-carousel/slick/slick.scss'
import 'slick-carousel/slick/slick-theme.scss'
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel';
import './owl.carousel.min'
import 'js-loading-overlay'
import imageCompression from 'browser-image-compression';
window.imageCompression = imageCompression;
import Swal from 'sweetalert2';
window.Swal = Swal;
import toastr from 'toastr';
window.toastr = toastr
import {compressImgUp} from './imageCompressor';
window.compressImgUp = compressImgUp
import {handleImageUpload} from "./compressedImage";
import Zooming from "./zoom";
window.handleImageUpload = handleImageUpload;
window.Zooming = Zooming;
import moment from 'moment';
// window.moment = moment;

$(window).on("load",function() {
    $.rails.refreshCSRFTokens();
})

